import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../shared';
import { SalesCommissionCycleContainerModel } from '../../../../../models/aggregates/sales-commission/sales-commission-cycle-container.model';

@Injectable({
    providedIn: 'root'
})
export class SalesCommissionCycleService extends BaseApiTemplateService<SalesCommissionCycleContainerModel> {

    //https://api.akaun.cloud/core2/tnt/dm/fi/sale-commission-cycle/backoffice-ep

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + "sale-commission-cycle/backoffice-ep";
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + "sale-commission-cycle/backoffice-ep";
        this.httpClient = http;
      }
}